import { connect } from 'react-redux';
import { actions } from '../../../../../redux/modules/clientes/clientes';
import ProveedoresGrid from './proveedoresGrid';

const mstp = state => {
    return {
        ...state.clientes,
        permisos: state.login.me.permisos,
    }
};

const mdtp = {
    ...actions,
};

export default connect(mstp,mdtp)(ProveedoresGrid);